import { render, staticRenderFns } from "./GeneratoreQR.vue?vue&type=template&id=389e9a00&scoped=true"
import script from "./GeneratoreQR.vue?vue&type=script&lang=js"
export * from "./GeneratoreQR.vue?vue&type=script&lang=js"
import style0 from "./GeneratoreQR.vue?vue&type=style&index=0&id=389e9a00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389e9a00",
  null
  
)

export default component.exports